export enum EnumClassNamePlanEnum {
    NOTIFICATION_TYPE = "App\\Model\\PhpEnum\\PlannerNotificationTypeEnum",
}
